import type { TableColumn } from 'liyu-pc-base/typing';
import type { Record, SearchConfig } from 'liyu-pc-base/components/remotePages/typing';
import { btn_list, config, head_btn_list } from './permission-apiurl-config';
import { event_obj } from 'liyu-pc-base/init-plugin';
import { reactive } from 'vue';

export default () => {
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '接口名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写接口名称',
      },
      {
        type: 'input',
        name: 'url',
        label: '绝对路径url',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写绝对路径url',
      },
      {
        type: 'radio',
        name: 'is_auth',
        label: '是否需要授权',
        disabled: false,
        labelKey: 'name',
        valueKey: 'value',
        placeholder: '请选择是否授权',
        datasource: 'is_auth',
        mode: 'default',
      },
      {
        type: 'radio',
        name: 'is_active',
        label: '状态',
        disabled: false,
        defaultValue: '',
        labelKey: 'name',
        valueKey: 'value',
        placeholder: '请选择状态',
        datasource: 'is_active',
        mode: 'default',
      },
    ],
    rules: {},
    model: reactive({
      is_active: true,
      is_auth: '',
      name: '',
      url: '',
    }),
    options: {
      is_active: [
        { name: '全部', value: '' },
        { name: '正常', value: true },
        { name: '作废', value: false },
      ],
      is_auth: [
        { name: '全部', value: '' },
        { name: '是', value: true },
        { name: '否', value: false },
      ],
    },
    default_column_field: ['is_auth', 'is_active'],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '接口名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '接口名称',
      },
      {
        type: 'input',
        name: 'url',
        label: '绝对路径',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '绝对路径',
      },
      {
        type: 'radio',
        name: 'is_auth', // 传值字段
        label: '是否需要授权',
        disabled: false,
        labelKey: 'name', // options数据
        valueKey: 'value',
        placeholder: '请选择是否授权',
        datasource: 'is_auth', // 接参字段
      },
    ],
    rules: {
      name: [{ required: true, message: '请输入接口名称' }],
      url: [{ required: true, message: '请输入绝对路径' }],
    },
    model: {
      name: '',
      url: '',
      is_auth: null,
    },
    options: {
      is_auth: [
        { name: '是', value: true },
        { name: '否', value: false },
      ],
    },
  };

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '接口名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '接口名称',
      },
      {
        type: 'input',
        name: 'url',
        label: '绝对路径',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '绝对路径',
      },
      {
        type: 'radio',
        name: 'is_auth', // 传值字段
        label: '是否需要授权',
        disabled: false,
        labelKey: 'name', // options数据
        valueKey: 'value',
        placeholder: '请选择是否授权',
        datasource: 'is_auth', // 接参字段
      },
    ],
    rules: {},
    model: reactive({
      name: '',
      url: '',
      is_auth: null,
      update_field_list: ['name', 'url', 'is_auth'],
    }),
    options: {
      is_auth: [
        { name: '是', value: true },
        { name: '否', value: false },
      ],
    },
  };

  const titleList = {
    title: '接口列表',
    addModalTitle: '新建接口',
    updateTitle: '修改',
    is_create: true, // 是否有【新建】按钮
    is_update: true, // 是否有【修改】按钮
    is_remove: true, // 是否有【删除】按钮
    is_recover: true, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      apiurl_id: 'id',
    },
    delete: {
      apiurl_id: 'id',
    },
    recover: {
      apiurl_id: 'id',
    },
    updateData: {
      apiurl_id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      width: 50,
      dataIndex: 'index',
      checked: true,
      fixed: 'left',
    },
    {
      title: '名称',
      dataIndex: 'name',
      checked: true,
      fixed: 'left',
    },
    {
      title: 'url',
      dataIndex: 'url',
      checked: true,
    },
    {
      title: '接口对应菜单',
      dataIndex: 'menu_list',
      checked: true,
      cellComponent: 'menu_list',
    },
    {
      title: '是否需要授权',
      width: 130,
      dataIndex: 'is_auth',
      checked: true,
      cellComponent: 'boolean',
      name1: '是',
      name2: '否',
    },
    {
      title: '是否可用',
      width: 100,
      dataIndex: 'is_active',
      checked: true,
      resizable: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '禁用',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: 'true' },
        { text: '禁用', value: 'false' },
      ],
    },
    {
      title: '操作',
      width: 170,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
    },
  ];

  return {
    searchConfig: search_config,
    formModalConfig: edit_model_config,
    updateFormModalConfig: update_model_config,
    queryData: '/permission/query_apiurl_list',
    addData: '/permission/create_apiurl',
    updateData: '/permission/update_apiurl',
    removeData: '/permission/delete_apiurl',
    recoverData: '/permission/recover_apiurl',
    baseColumns: baseColumns,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj(),
    base_search_condition_config_list: [],
    default_search_condition_config_list: [[]],
    condition_group_config_list: [],
    is_show_advantage: false,
    is_show_normal_search: true,
    is_only_show_advantage: false,
    is_only_show_normal_search: true,
    queryConditionGroupData: null,
    isView: false,
  };
};
